module.exports = __webpack_public_path__ + "images/80cdb2567bfa0103fbbfb573784d479cibm_blacklogo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ibm_blacklogo.png
// module id = RnNM
// module chunks = 0